import { Injectable } from '@angular/core';
//import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { EnumEntity } from '../model/entity';
import { EnumLegalEntityRole, LegalEntityInfo } from '../model/legal-entity-info';
import { Role } from '../model/role';
import { EnumUserLegalEntityRole, EnumUserRole } from '../model/user-basic-info';
import { UserInfo } from '../model/user-info';
import { LegalEntityAddressInfo } from '../model/legal-entity-address-info';
import { UserLegalEntityAttributesBasicInfo } from '../model/user-legal-entity-attributes-basic-info';
import { SharedUtils } from '../utilities/shared-utils';
import { CitizenInfo } from '../model/citizen-info';
import { CitizenAddressInfo } from '../model/citizen-address-info';

@Injectable({
  providedIn: 'root'
})
export class WinoCookieService {

    clientUserInfo: UserInfo;

  constructor(/*private readonly localStorage: LocalStorageService, private readonly sessionStorage: SessionStorageService,*/
    private readonly cookieService: CookieService) { }

  private isInLocalStorage(key: string): boolean {
    //console.log("IS IN LOCAL STORAGE???? - " + key);
    //const data01: any = JSON.parse(localStorage.getItem(key));
    //const data02: any = localStorage.getItem(key);
    //console.log("IS IN LOCAL STORAGE???? - " + key + " - VALUE: " + data01);
    //console.log("IS IN LOCAL STORAGE???? - " + key + " - VALUE: " + data02);
    return ( !!localStorage.getItem(key) );
  }

  private isInSessionStorage(key: string): boolean {
    //console.log("IS IN SESSION STORAGE???? - " + key);
    //const data01: any = JSON.parse(sessionStorage.getItem(key));
    //const data02: any = sessionStorage.getItem(key);
    //console.log("IS IN SESSION STORAGE???? - " + key + " - VALUE: " + data01);
    //console.log("IS IN SESSION STORAGE???? - " + key + " - VALUE: " + data02);
    return ( !!sessionStorage.getItem(key) );
    //return ( sessionStorage.getItem(key) !== undefined );
  }

  public disclaimerViewed(): boolean {
    return ( this.isInLocalStorage('cookiesDisclaimerViewed') && this.isInLocalStorage('cookiesAccepted') );
  }

  private cookiesAccepted(): boolean {
    return localStorage.getItem("cookiesAccepted").toLowerCase() === 'true';
  }
/**********
  public clearAllCookies(): boolean {
    localStorage.clear();
    sessionStorage.clear();
    return true;
  }
  **************/

  private clearDisclaimerViewed() {
        localStorage.removeItem("cookiesAccepted");
        localStorage.removeItem('cookiesDisclaimerViewed');
        sessionStorage.removeItem("cookiesAccepted");
        sessionStorage.removeItem('cookiesDisclaimerViewed');
        return true;
    }

    public isAuthenticated(): boolean {
        if ( (this.isInSessionStorage('userInfo') && this.isInSessionStorage('userRoles')) ||
        (this.isInLocalStorage('userInfo') && this.isInLocalStorage('userRoles')) ) {
            return true;
        } else {
            return false;
        }
    }

    public checkAuthentication(): string {

        //console.log("IS AUTHENTICATED COOKIE CHECK: " + environment.authenticationTypeCookieName + " ... present? " + 
        //        this.cookieService.check(environment.authenticationTypeCookieName));

        if ( (this.isInSessionStorage('userInfo') && this.isInSessionStorage('userRoles')) ||
        (this.isInLocalStorage('userInfo') && this.isInLocalStorage('userRoles')) ) {
            //console.log("Local / session data found");
            if ( this.cookieService.check(environment.authenticationTypeCookieName) ) {
                return "true";
            } else {
                this.logout();
                return "clean";
            }
        } else {
            //console.log("Local / session data NOT found");
            if ( this.cookieService.check(environment.authenticationTypeCookieName) ) {
                this.logout();
                return "clean";
            } else {
                return "false";
            }
        }

/************************************************************
        if (  ( (this.isInSessionStorage('userInfo') && this.isInSessionStorage('userRoles')) ||
            (this.isInLocalStorage('userInfo') && this.isInLocalStorage('userRoles')) ) &&
            this.cookieService.check(environment.authenticationTypeCookieName) ) {
            //console.log("COOKIE SERVICE - Is authenticated.... cokies found: ");
            //console.log(this.cookieService.get(environment.authenticationTypeCookieName));
            //console.log(this.cookieService.get(environment.authenticationAuthTokenCookieName));
            //console.log(this.cookieService.get(environment.authenticationRefreshTokenCookieName));
                //console.log("COOKIE SERVICE - isAutheticated? YES");
            return "true";
        } else {
            console.log("COOKIE SERVICE - isAutheticated? NO.... deleting cookies: ");
            console.log(this.cookieService.get(environment.authenticationTypeCookieName));
            //console.log(this.cookieService.get(environment.authenticationAuthTokenCookieName));
            //console.log(this.cookieService.get(environment.authenticationRefreshTokenCookieName));
            this.logout();
            return false;
        }
**************************************************************/
    }

    public login(userInfo: UserInfo): boolean {
        if (this.cookieService.get(environment.authenticationTypeCookieName) === environment.authenticationTypeCookieValue_session) {
            console.log("WinoCookieService - login: cookie " + environment.authenticationTypeCookieName + ": " + environment.authenticationTypeCookieValue_session);
            this.newSessionLogin(userInfo);
            return true;
        }
        if (this.cookieService.get(environment.authenticationTypeCookieName) === environment.authenticationTypeCookieValue_local) {
            console.log("WinoCookieService - login: cookie " + environment.authenticationTypeCookieName + ": " + environment.authenticationTypeCookieValue_local);
            this.newLocalLogin(userInfo);
            return true;
        }
        this.logout();
        return false;
    }
    
    public logout() {
        //this.cookieService.delete(environment.authenticationTypeCookieName, '/', environment.membershipBackendHost);
        //this.cookieService.delete(environment.authenticationAuthTokenCookieName, '/', environment.membershipBackendHost);
        //this.cookieService.delete(environment.authenticationRefreshTokenCookieName, '/', environment.membershipBackendHost);
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userRoles');
        localStorage.removeItem('userLegalEntityRoles');
        sessionStorage.removeItem('userInfo');
        sessionStorage.removeItem('userRoles');
        sessionStorage.removeItem('userLegalEntityRoles');
        this.clientUserInfo = undefined;
        //sessionStorage.clear('userRoles');
    }

    private newSessionLogin(userInfo: UserInfo): void {
        localStorage.setItem('cookiesDisclaimerViewed', 'true');
        localStorage.setItem('cookiesAccepted', 'true');
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.parseUserAuthRoles("session");
        this.parseUserLegalEntityAuthRoles("session");
        //sessionStorage.setItem('userRoles', JSON.stringify(this.parseUserAuthRoles("session")));

        // console.log("WinoCookieService - newSessionLogin: " +
        //     localStorage.getItem("cookiesDisclaimerViewed") +
        //     ", " + localStorage.getItem("cookiesAccepted") + 
        //     ", " + sessionStorage.getItem("userInfo") +
        //     ", " + sessionStorage.getItem("userRoles"));
    }

    private newLocalLogin(userInfo: UserInfo): void {
        localStorage.setItem('cookiesDisclaimerViewed', 'true');
        localStorage.setItem('cookiesAccepted', 'true');
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.parseUserAuthRoles("local");
        this.parseUserLegalEntityAuthRoles("local");
        // localStorage.setItem('userRoles', JSON.stringify(this.parseUserAuthRoles("local")));

        // console.log("WinoCookieService - newSessionLogin: " +
        //     localStorage.getItem("cookiesDisclaimerViewed") +
        //     ", " + localStorage.getItem("cookiesAccepted") + 
        //     ", " + localStorage.getItem("userInfo") +
        //     ", " + localStorage.getItem("userRoles"));
    }

    public updateClientUserInfo(newUserInfo: UserInfo): boolean {
        if (this.cookieService.get(environment.authenticationTypeCookieName) === environment.authenticationTypeCookieValue_session) {
            this.newSessionLogin(newUserInfo);
            this.clientUserInfo = Object.assign(new UserInfo(), newUserInfo);
            return true;
        }
        if (this.cookieService.get(environment.authenticationTypeCookieName) === environment.authenticationTypeCookieValue_local) {
            this.newLocalLogin(newUserInfo);
            this.clientUserInfo = Object.assign(new UserInfo(), newUserInfo);
            return true;
        }
        this.logout();
        return false;
    }

    public acceptCookies() {
        localStorage.setItem('cookiesDisclaimerViewed', 'true');
        localStorage.setItem('cookiesAccepted', 'true');
    }

    public refuseCookies() {
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('cookiesDisclaimerViewed', 'true');
        localStorage.setItem('cookiesAccepted', 'false');
    }
/***************************
    private setClientActiveLegalEntityInfo(legalEntityInfo: LegalEntityInfo): boolean {
        try {
            this.clientUserInfo.setActiveLegalEntityInfo(legalEntityInfo);

        } catch {
            return false;
        }
        if ( this.isInSessionStorage('userInfo') ) {
            sessionStorage.setItem('userInfo', JSON.stringify(this.getClientUserinfo));
        }
        if ( this.isInLocalStorage('userInfo') ) {
            sessionStorage.setItem('userInfo', JSON.stringify(this.getClientUserinfo));
        }
        return true;
    }
    **************************/

    public setClientWineSearchCategory(enumEntity: EnumEntity): void {
        localStorage.setItem("wineSearchCategory", enumEntity.toString());
    }

    public getLoginDuration(): string {
        if(this.cookieService.check(environment.authenticationTypeCookieName)) {
            return this.cookieService.get(environment.authenticationTypeCookieName)
        }
        return "";
    }

    public logDisclaimerCookies() {
    console.debug(`Cookies Disclaimer: disclaimer viewed: ${localStorage.getItem('cookiesDisclaimerViewed')}; 
                  cookies accepted: ${localStorage.getItem('cookiesAccepted')}.`);
  }

    public getClientUserRoles(): Array<string> {
        if ( this.isInSessionStorage('userInfo') ) {
            return JSON.parse(sessionStorage.getItem('userRoles'));
        }
        if ( this.isInLocalStorage('userInfo') ) {
            return JSON.parse(localStorage.getItem('userRoles'));
        }
        return null;
    }

    public getClientUserinfo(): UserInfo {
        if(SharedUtils.inputValueIsPresent(this.clientUserInfo)) {
            return this.clientUserInfo;
        } else {
            this.retrieveStringifiedUserInfo();
            return this.clientUserInfo;
        }
    }

    public getClientUserNickname(): string | undefined {
        if(SharedUtils.inputValueIsPresent(this.clientUserInfo)) {
            return this.clientUserInfo.nickname;
        }
        if ( this.isInSessionStorage('userInfo') ) {
            let userinfos: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            console.log("USER INFO NICKNAME: " + userinfos.nickname);
            return userinfos.nickname;
        }
        if ( this.isInLocalStorage('userInfo') ) {
            let userinfos: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            // console.log("USER INFO NICKNAME: " + userinfos.nickname);
            return userinfos.nickname;
        }
        return undefined;
    }

  public getClientCitizenFullName(): string | undefined {
        if( SharedUtils.inputValueIsPresent(this.clientUserInfo) && SharedUtils.inputValueIsPresent(this.clientUserInfo.citizenInfo) ) {
            return ( this.clientUserInfo.citizenInfo.firstName + " " + this.clientUserInfo.citizenInfo.lastName );
        }
        if ( this.isInSessionStorage('userInfo') ) {
            let userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            if (userInfo?.citizenInfo) {
                return ( userInfo.citizenInfo.firstName + " " + userInfo.citizenInfo.lastName );
            }
        }
        if ( this.isInLocalStorage('userInfo') ) {
            let userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (userInfo?.citizenInfo) {
                return ( userInfo.citizenInfo.firstName + " " + userInfo.citizenInfo.lastName );
            }
        }
        return undefined;
    }

    /****************************************
    private getClientActiveLegalEntityInfo(): LegalEntityInfo | undefined {
        if( SharedUtils.inputValueIsPresent(this.clientUserInfo) && SharedUtils.inputValueIsPresent(this.clientUserInfo.activeLegalEntityInfo) ) {
            return this.clientUserInfo.activeLegalEntityInfo;
        }
        if (this.isInSessionStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            return ( userInfo.activeLegalEntityInfo );
        }
        if (this.isInLocalStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            return ( userInfo.activeLegalEntityInfo );
        }
        return undefined;
    }
        *************************************/

    public getClientActiveLegalEntityReference(): string | undefined {
        if( SharedUtils.inputValueIsPresent(this.clientUserInfo) && SharedUtils.inputValueIsPresent(this.clientUserInfo.activeLegalEntityInfo) ) {
            return (this.clientUserInfo.activeLegalEntityInfo.companyName + " (" +  this.clientUserInfo.activeLegalEntityInfo.vatNumber + ")");
        }
        if (this.isInSessionStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            if (userInfo?.activeLegalEntityInfo) {
                return ( userInfo.activeLegalEntityInfo.companyName + " (" +  userInfo.activeLegalEntityInfo.vatNumber + ")" );
            }
        }
        if (this.isInLocalStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (userInfo?.activeLegalEntityInfo) {
                return ( userInfo.activeLegalEntityInfo.companyName + " (" +  userInfo.activeLegalEntityInfo.vatNumber + ")" );
            }
        }
        return undefined;
    }

    public getUserLegalEntitiesAttributesBasicInfo(): Set<UserLegalEntityAttributesBasicInfo> | undefined {
        if( SharedUtils.inputValueIsPresent(this.clientUserInfo) && SharedUtils.inputValueIsPresent(this.clientUserInfo.userLegalEntitiesAttributesBasicInfo) ) {
            let attributesBasicInfo: Set<UserLegalEntityAttributesBasicInfo> = new Set<UserLegalEntityAttributesBasicInfo>();
            this.clientUserInfo.userLegalEntitiesAttributesBasicInfo.forEach( (entity: UserLegalEntityAttributesBasicInfo) => {
                attributesBasicInfo.add(entity);
            });
            return attributesBasicInfo;
        }
        if (this.isInSessionStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            if (userInfo?.userLegalEntitiesAttributesBasicInfo) {
                let attributesBasicInfo: Set<UserLegalEntityAttributesBasicInfo> = new Set<UserLegalEntityAttributesBasicInfo>();
                userInfo.userLegalEntitiesAttributesBasicInfo.forEach( (entity: UserLegalEntityAttributesBasicInfo) => {
                    attributesBasicInfo.add(entity);
                });
                return attributesBasicInfo;
            }
        }
        if (this.isInLocalStorage('userInfo')) {
            let userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (userInfo?.userLegalEntitiesAttributesBasicInfo) {
                let attributesBasicInfo: Set<UserLegalEntityAttributesBasicInfo> = new Set<UserLegalEntityAttributesBasicInfo>();
                userInfo.userLegalEntitiesAttributesBasicInfo.forEach( (entity: UserLegalEntityAttributesBasicInfo) => {
                    attributesBasicInfo.add(entity);
                });
                return attributesBasicInfo;
            }
        }
        return undefined;
    }

    public getClientUserStatusId(): number | undefined {
        if ( this.isInSessionStorage('userInfo') ) {
            return +JSON.parse(sessionStorage.getItem('userInfo')).statusId;
        }
        if ( this.isInLocalStorage('userInfo') ) {
            return +JSON.parse(localStorage.getItem('userInfo')).statusId;
        }
        return undefined;
    }

    public getClientUserEmail(): string | undefined {
        if ( SharedUtils.inputValueIsPresent(this.clientUserInfo.email) ) {
            return this.clientUserInfo.email;
        }
        if ( this.isInSessionStorage('userInfo') ) {
            const userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.clientUserInfo = Object.assign(new UserInfo() , userInfo);
            return this.clientUserInfo.email;
        }
        if ( this.isInLocalStorage('userInfo') ) {
            const userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.clientUserInfo = Object.assign(new UserInfo() , userInfo);
            return this.clientUserInfo.email;
        }
        return undefined;
    }

    public getClientUserId(): number | undefined {
        if(this.clientUserInfo?.id) {
            return this.clientUserInfo.id;
        }
        if ( this.isInSessionStorage('userInfo') ) {
            const userInfo: UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.clientUserInfo = Object.assign(new UserInfo() , userInfo);
            return this.clientUserInfo.id;
        }
        if ( this.isInLocalStorage('userInfo') ) {
            const userInfo: UserInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.clientUserInfo = Object.assign(new UserInfo() , userInfo);
            return this.clientUserInfo.id;
        }
        return undefined;
    }

    public getClientUserInstagramNickname(): string |undefined {
    if ( this.isInSessionStorage('userInfo') ) {
      return JSON.parse(sessionStorage.getItem('userInfo')).instagramNickname;
    }
    if ( this.isInLocalStorage('userInfo') ) {
      return JSON.parse(localStorage.getItem('userInfo')).instagramNickname;
    }
    return undefined;
  }

  public getClientWineSearchCategory(): string | undefined {
      if ( this.isInLocalStorage('wineSearchCategory') ) {
          return localStorage.getItem('wineSearchCategory');
      } else {
          return undefined;
      }
  }

    private retrieveStringifiedUserInfo(): void {
        let stringifiedUserInfo: UserInfo = new UserInfo();
        if ( this.isInSessionStorage('userInfo') ) {
            stringifiedUserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        }
        if ( this.isInLocalStorage('userInfo') ) {
            stringifiedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
        }
        this.clientUserInfo = new UserInfo();
        this.clientUserInfo = this.parseUserInfo(stringifiedUserInfo);
    }

    private parseUserInfo(stringifiedUserInfo: UserInfo): UserInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedUserInfo)) {
            return undefined;
        }
        let newUserInfo: UserInfo = new UserInfo();

        newUserInfo.id = stringifiedUserInfo.id;
        newUserInfo.nickname = stringifiedUserInfo.nickname;
        newUserInfo.email = stringifiedUserInfo.email;
        // newUserInfo.token = stringifiedUserInfo.token;
        newUserInfo.statusId = stringifiedUserInfo.statusId;
        newUserInfo.instagramNickname = stringifiedUserInfo.instagramNickname;
        newUserInfo.creationDate = new Date(stringifiedUserInfo.creationDate);
        newUserInfo.roles = new Array<EnumUserRole>();
        if (stringifiedUserInfo.roles) {
            let counter: number = stringifiedUserInfo.roles.length;
            for (let i : number = 0; i < counter; i++) {
                newUserInfo.roles.push(EnumUserRole[stringifiedUserInfo.roles[i]]);
            }
        } else {
            throw new Error("ERROR - CookieService: User profile not found:  UserInfo.userRoles: " + stringifiedUserInfo.roles);
        }
        // newUserInfo.password = stringifiedUserInfo.password;
        // newUserInfo.confirmPassword = stringifiedUserInfo.confirmPassword;
        newUserInfo.citizenInfo = this.parseCitizenInfo(stringifiedUserInfo.citizenInfo);
        newUserInfo.activeLegalEntityInfo = this.parseLegalEntityInfo(stringifiedUserInfo.activeLegalEntityInfo);
        newUserInfo.userLegalEntitiesAttributesBasicInfo = this.parseUserLegalEntitiesAttributesBasicInfo(stringifiedUserInfo.userLegalEntitiesAttributesBasicInfo);
        newUserInfo.userActiveLegalEntityRoles = stringifiedUserInfo.userActiveLegalEntityRoles
        newUserInfo.userActiveLegalEntityProfile = stringifiedUserInfo.userActiveLegalEntityProfile;
        return newUserInfo;
    }

    private parseCitizenInfo(stringifiedCitizenInfo: CitizenInfo): CitizenInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedCitizenInfo)) {
            return undefined;
        }
        let newCitizenInfo: CitizenInfo = new CitizenInfo();
        newCitizenInfo.id = stringifiedCitizenInfo.id;
        newCitizenInfo.statusId = stringifiedCitizenInfo.statusId;
        newCitizenInfo.fiscalCode = stringifiedCitizenInfo.fiscalCode;
        newCitizenInfo.firstName = stringifiedCitizenInfo.firstName;
        newCitizenInfo.lastName = stringifiedCitizenInfo.lastName;
        newCitizenInfo.phoneNumber = stringifiedCitizenInfo.phoneNumber;
        newCitizenInfo.companyName = stringifiedCitizenInfo.companyName;
        newCitizenInfo.vatNumber = stringifiedCitizenInfo.vatNumber;
        newCitizenInfo.billingSdiCode = stringifiedCitizenInfo.billingSdiCode;
        newCitizenInfo.shippingAddress = this.parseCitizenAddressInfo(stringifiedCitizenInfo.shippingAddress);
        newCitizenInfo.billingAddress = this.parseCitizenAddressInfo(stringifiedCitizenInfo.billingAddress);
       //  newCitizenInfo.citizenAddressesInfo = stringifiedCitizenInfo.citizenAddressesInfo;

        return newCitizenInfo;
    }

    private parseCitizenAddressInfo(stringifiedCitizenAddressInfo: CitizenAddressInfo): CitizenAddressInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedCitizenAddressInfo)) {
            return undefined;
        }
        let newCitizenAddressInfo: CitizenAddressInfo = new CitizenAddressInfo();
        newCitizenAddressInfo.id = stringifiedCitizenAddressInfo.id;
        newCitizenAddressInfo.statusId = stringifiedCitizenAddressInfo.statusId;
        newCitizenAddressInfo.defaultShipping = stringifiedCitizenAddressInfo.defaultShipping;
        newCitizenAddressInfo.defaultBilling = stringifiedCitizenAddressInfo.defaultBilling;
        newCitizenAddressInfo.verified = stringifiedCitizenAddressInfo.verified;
        newCitizenAddressInfo.addressComplete = stringifiedCitizenAddressInfo.addressComplete;
        newCitizenAddressInfo.formattedAddress = stringifiedCitizenAddressInfo.formattedAddress;

        return newCitizenAddressInfo;
    }

    private parseLegalEntityInfo(stringifiedLegalEntityInfo: LegalEntityInfo): LegalEntityInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedLegalEntityInfo)) {
            return undefined;
        }
        let newLegalEntityInfo: LegalEntityInfo = new LegalEntityInfo();
        
        newLegalEntityInfo.id = stringifiedLegalEntityInfo.id;
        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityInfo.roles)) {
            let counter: number = stringifiedLegalEntityInfo.roles.length;
            for (let i : number = 0; i < counter; i++) {
                newLegalEntityInfo.roles = new Array<EnumLegalEntityRole>();
                newLegalEntityInfo.roles.push(stringifiedLegalEntityInfo.roles[i]);
            }
        } else {
            throw new Error("ERROR - CookieService: Legal Entity profile not found:  LegalEntityInfo.legalEntityRoles: " + stringifiedLegalEntityInfo.roles);
        }
        newLegalEntityInfo.statusId = stringifiedLegalEntityInfo.statusId;
        newLegalEntityInfo.companyName = stringifiedLegalEntityInfo.companyName;
        newLegalEntityInfo.brandName = stringifiedLegalEntityInfo.brandName;
        newLegalEntityInfo.legalFormId = stringifiedLegalEntityInfo.legalFormId;
        newLegalEntityInfo.fiscalCode = stringifiedLegalEntityInfo.fiscalCode;
        newLegalEntityInfo.vatNumber = stringifiedLegalEntityInfo.vatNumber;
        // newLegalEntityInfo.legalEntityAddressInfo = this.parseLegalEntityAddressInfo(stringifiedLegalEntityInfo.legalEntityAddressInfo);
        return newLegalEntityInfo;
    }

    private parseLegalEntityAddressInfo(stringifiedlegaleEntityAddressInfo: LegalEntityAddressInfo): LegalEntityAddressInfo {
        if(SharedUtils.inputValueIsEmpty(stringifiedlegaleEntityAddressInfo)) {
            return undefined;
        }
        let newLegalEntityAddressInfo: LegalEntityAddressInfo = new LegalEntityAddressInfo();
        newLegalEntityAddressInfo.id = stringifiedlegaleEntityAddressInfo.id;
        newLegalEntityAddressInfo.statusId = stringifiedlegaleEntityAddressInfo.statusId;
        newLegalEntityAddressInfo.defaultShipping = stringifiedlegaleEntityAddressInfo.defaultShipping;
        newLegalEntityAddressInfo.defaultBilling = stringifiedlegaleEntityAddressInfo.defaultBilling;
        newLegalEntityAddressInfo.verified = stringifiedlegaleEntityAddressInfo.verified;
        newLegalEntityAddressInfo.addressComplete = stringifiedlegaleEntityAddressInfo.addressComplete;
        newLegalEntityAddressInfo.formattedAddress = stringifiedlegaleEntityAddressInfo.formattedAddress;
        newLegalEntityAddressInfo.registeredOffice = stringifiedlegaleEntityAddressInfo.registeredOffice;
        newLegalEntityAddressInfo.commercialOffice = stringifiedlegaleEntityAddressInfo.commercialOffice;
        newLegalEntityAddressInfo.fiscalOffice = stringifiedlegaleEntityAddressInfo.fiscalOffice;
        newLegalEntityAddressInfo.operativeOffice = stringifiedlegaleEntityAddressInfo.operativeOffice;
        newLegalEntityAddressInfo.email = stringifiedlegaleEntityAddressInfo.email;
        return newLegalEntityAddressInfo;
    }

    private parseUserLegalEntitiesAttributesBasicInfo(stringifiedlUserLegalEntitiesAttributesBasicInfo: UserLegalEntityAttributesBasicInfo[]): UserLegalEntityAttributesBasicInfo[] {
        if(SharedUtils.inputValueIsEmpty(stringifiedlUserLegalEntitiesAttributesBasicInfo) || stringifiedlUserLegalEntitiesAttributesBasicInfo.length < 1) {
            return undefined;
        }
        let newUserLegalEntitiesAttributesBasicInfo: UserLegalEntityAttributesBasicInfo[] = new Array<UserLegalEntityAttributesBasicInfo>();

        stringifiedlUserLegalEntitiesAttributesBasicInfo.forEach( ( stringifiedBasicInfo: UserLegalEntityAttributesBasicInfo) => {
            let basicInfo: UserLegalEntityAttributesBasicInfo = new UserLegalEntityAttributesBasicInfo();
            basicInfo.userId = stringifiedBasicInfo.userId;
            basicInfo.legalEntityId = stringifiedBasicInfo.legalEntityId;
            basicInfo.legalEntityCompanyName = stringifiedBasicInfo.legalEntityCompanyName;
            basicInfo.legalEntityFiscalCode = stringifiedBasicInfo.legalEntityFiscalCode;
            newUserLegalEntitiesAttributesBasicInfo.push(basicInfo);
        });
        return newUserLegalEntitiesAttributesBasicInfo;
    }

    private parseUserAuthRoles(repository: string): boolean {
        let rolesList: Array<string> = new Array<string>();
        const userRoles: Array<EnumUserRole> =  repository === "session" ? 
        JSON.parse(sessionStorage.getItem('userInfo')).roles :
        JSON.parse(localStorage.getItem('userInfo')).roles;
        if (userRoles) {
            let counter: number = userRoles.length;
            for (let i : number = 0; i < counter; i++) {
                rolesList.push(new Role(userRoles[i]).roleFullIdentifier);
            }
        } else {
            throw new Error("ERROR - CookieService: User profile not found:  UserInfo.userRoles: " + userRoles);
        }
        if (repository === "session") {
            sessionStorage.setItem('userRoles', JSON.stringify(rolesList));
        } else {
            localStorage.setItem('userRoles', JSON.stringify(rolesList));
        }
        return true;
    }

    private parseUserLegalEntityAuthRoles(repository: string): boolean {
        const legalEntityRoles: Array<EnumLegalEntityRole> = ( repository === "session" ?
            JSON.parse(sessionStorage.getItem('userInfo'))?.activeLegalEntityInfo?.roles : 
            JSON.parse(localStorage.getItem('userInfo'))?.activeLegalEntityInfo?.roles
        );
        const userLegalEntityRoles: Array<EnumUserLegalEntityRole> = ( repository === 'session' ?
            JSON.parse(sessionStorage.getItem("userInfo"))?.userActiveLegalEntityRoles :
            JSON.parse(localStorage.getItem("userInfo"))?.userActiveLegalEntityRoles
        );
        if (SharedUtils.inputValueIsPresent(legalEntityRoles) &&
            SharedUtils.inputValueIsPresent(userLegalEntityRoles) &&
            legalEntityRoles.length > 0 && userLegalEntityRoles.length > 0) {
            let rolesList: Array<string> = new Array<string>();

            let legalEntityCounter: number = legalEntityRoles.length;
            let userCounter: number = userLegalEntityRoles.length;
            for (let i : number = 0; i < legalEntityCounter; i++) {
                for(let n: number = 0; n < userCounter; n++) {
                    rolesList.push(new Role(EnumUserRole.NONE, legalEntityRoles[i], userLegalEntityRoles[n]).roleFullIdentifier);
                }
            }
            if (repository === "session") {
                sessionStorage.setItem('userLegalEntityRoles', JSON.stringify(rolesList));
            } else {
                localStorage.setItem('userLegalEntityRoles', JSON.stringify(rolesList));
            }
        } else {
            return false;
        }
        return true;
    }

    private samples(): void {
        //sessionStorage.set('Application running', 'WINO')
        //console.log("Wino - list of session variables: " + sessionStorage.keys);
        //console.log("Number or session variables: " + sessionStorage.length);
        //console.log("Name of the application runing: " + sessionStorage.get('Application running', 'unknown'));
        sessionStorage.setItem('objectSample', JSON.stringify({firstValue: 'one', secondValue: 'two', thirdValue: 'three'}));
        //console.log("An object sample: " + sessionStorage.getObject('objectSample'));
        /*************************
        //console.log("Session variables list:");
        for (let entry of sessionStorage.getStrategyName()) {
            //console.log(entry);
        }

        //console.log("Local variables list:");
        for (let entry of localStorage.getStrategyName()) {
            //console.log(entry);
        }
        **************************/
    }
}